export const FLOW_CONTAINER_ID = 'J_FlowContainer';
export const LABEL_DEFAULT_TEXT = 'New Node';

export enum RendererType {
  Canvas = 'canvas',
  Svg = 'svg',
}

export enum ItemType {
  Node = 'node',
  Edge = 'edge',
}

export enum ItemState {
  Active = 'active',
  ActiveAnchorPoints = 'activeAnchorPoints',
  Error = 'error',
  HighLight = 'highLight',
  HoverNumOfUser = 'hoverNumOfUser',
  HoverNumOfUserEntered = 'hoverNumOfUserEntered',
  HoverNumOfUserExited = 'hoverNumOfUserExited',
  InlineEdit = 'inlineEdit',
  Selected = 'selected',
  AIGenerated = 'aiGenerated',
}

interface ItemStateDataMap {
  [key: string]: string;
}

/**
 * Map linking the state name and it's corresponding value on the model
 * EG: if the state is `ItemState.InlineEdit`, it should also be able to be set
 * by putting the following on the node data:
 * {
 *    isInlineEditInProgress: true
 * }
 */
export const itemStateDataMap: ItemStateDataMap = [
  ['isActive', ItemState.Active],
  ['isInlineEditInProgress', ItemState.InlineEdit],
  ['isSelected', ItemState.Selected],
  ['isAIGenerated', ItemState.AIGenerated],
  ['isError', ItemState.Error],
].reduce((acc, [dataValue, state]) => ({ ...acc, [dataValue]: state, [state]: dataValue }), {});

// Are you able to perform actions (such as connect to nodes)
// from an anchor point?
export enum AnchorPointState {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum AnchorType {
  In = 'in',
  Out = 'out',
}

export enum GraphType {
  Flow = 'flow',
  Mind = 'mind',
}

export enum GraphMode {
  Default = 'default',
  AddNode = 'addNode',
  OverlayVisible = 'overlayVisible',
  Readonly = 'readonly',
  JourneyAssistActive = 'journeyAssistActive',
}

export enum GraphState {
  NodeSelected = 'nodeSelected',
  EdgeSelected = 'edgeSelected',
  MultiSelected = 'multiSelected',
  CanvasSelected = 'canvasSelected',
}

export enum InlineEditState {
  Hide = 'hide',
  Show = 'show',
}

export enum EditorCommand {
  /** Undo */
  Undo = 'undo',
  /** Redo */
  Redo = 'redo',
  /** Add */
  Add = 'add',
  /** Update */
  Update = 'update',
  /** Remove */
  Remove = 'remove',
  /** Copy */
  Copy = 'copy',
  /** Paste */
  Paste = 'paste',
  /** Paste Here */
  PasteHere = 'pasteHere',
  /** Zoom In */
  ZoomIn = 'zoomIn',
  /** Zoom Out */
  ZoomOut = 'zoomOut',
  /** Insert Topic */
  Topic = 'topic',
  /** Inset Subtopic */
  Subtopic = 'subtopic',
  /** Fold */
  Fold = 'fold',
  /** Unfold */
  Unfold = 'unfold',
}

export enum ContextMenuType {
  Canvas = 'canvas',
  Node = 'node',
  Edge = 'edge',
}

export const ZOOM_DELTA = 0.05;

export enum ViewportChangeType {
  Zoom = 'zoom',
  Translate = 'translate',
  Move = 'move',
}

export enum GraphBehavior {
  ActivateRelations = 'activate-relations',
  BrushSelect = 'brush-select',
  ClickSelect = 'click-select',
  CollapseExpand = 'collapse-expand',
  CollapseExpandCombo = 'collapse-expand-combo',
  CollapseExpandGroup = 'collapse-expand-group',
  CreateEdge = 'create-edge',
  DoubleClickNode = 'double-click-node',
  DragAddNode = 'drag-add-node',
  DragCanvas = 'drag-canvas',
  DragCombo = 'drag-combo',
  DragGroup = 'drag-group',
  DragNode = 'drag-node',
  DragNodeWithGroup = 'drag-node-with-group',
  EdgeTooltip = 'edge-tooltip',
  HoverItem = 'hover-item',
  LassoSelect = 'lasso-select',
  RecallEdge = 'recall-edge',
  ScrollCanvas = 'scroll-canvas',
  ShortcutsCall = 'shortcuts-call',
  Tooltip = 'tooltip',
  ZoomCanvas = 'zoom-canvas',
}
